export default {"src":"/_next/static/media/GooglePlayText.8b2de0d1.svg","height":19,"width":88,"blurWidth":0,"blurHeight":0};